export enum UserGroup {
  external = 'external',
  administrator = 'administrator',
  editor = 'editor',
  superuser = 'superuser',
}
